// Update and mirror _new_theme.scss when updating this file!

/*
A WORD OF WARNING!
SCSS outputs these variables as css variables. Since we've moved to using those
in production we need to make sure that we don't overwrite them here. If you need to
change a variable that is also a css variable, you'll need to change it in both places.
*/

let newTheme = {
  /* All Ears identify colors */
  /* primary colors */
  primary: "#6a378d",
  "primary-dark": "#552478",
  "primary-light": "#a174d9",
  secondary: "#d0b7f8",

  /* primary scale */
  "primary-900": "#552478",
  "primary-800": "#6a378d",
  "primary-700": "#8756b7",
  "primary-600": "#a174d9",
  "primary-500": "#ac87da",
  "primary-400": "#c09fe8",
  "primary-300": "#d0b7f8",
  "primary-200": "#dac5fb",
  "primary-100": "#e2d0ff",
  "primary-50": "#f2eaff",

  /* blues */
  "blue-darkdark": "#0f1333",
  "blue-900": "#195784",
  "blue-800": "#32709d",
  "blue-700": "#468cbf",
  "blue-600": "#58a0d4",
  "blue-500": "#73a3d9",
  "blue-400": "#8fbbed",
  "blue-300": "#aed6f6",
  "blue-200": "#d0ebff",
  "blue-100": "#e7f5ff",
  "blue-50": "#f1f9ff",

  /* pinks */
  "pink-900": "#7c1f79",
  "pink-800": "#a52f8b",
  "pink-700": "#b34b9b",
  "pink-600": "#be60a3",
  "pink-500": "#c775b0",
  "pink-400": "#dba3cb",
  "pink-300": "#dcb4d1",
  "pink-200": "#f3dced",
  "pink-100": "#faebf6",
  "pink-50": "#fff6fd",

  /* secondary colors */
  "ae-red": "#dd4b60",
  "ae-yellow": "#f1dd4a",
  "ae-dark-blue": "#0f1333",
  "ae-teal": "#a0c8cd",
  "ae-green": "#31a272",

  /* grays */
  "gray-900": "#212121",
  "gray-800": "#424242",
  "gray-700": "#616161",
  "gray-600": "#757575",
  "gray-500": "#9e9e9e",
  "gray-400": "#bdbdbd",
  "gray-300": "#e0e0e0",
  "gray-200": "#eeeeee",
  "gray-100": "#f5f5f5",
  "gray-50": "#fafafa",

  /* sentiments */
  "sentiment-negative": "#dd4b60",
  "sentiment-negative-light": "#ffc7c7",
  "sentiment-warning": "#ffd419",
  "sentiment-warning-light": "#ffe576",
  "sentiment-positive": "#31a272",
  "sentiment-positive-light": "#b9edd7",
  "sentiment-very-positive": "#118e58",
  "sentiment-very-negative": "#B0182E",

  /* generic */
  white: "#fff",
  black: "#000",

  "off-black": "#212121",
  "off-white": "#fafafa",
  "color-default": "off-black",
  muted: "#616161",

  /* font-sizes */
  "font-size-base": "1rem",

  "font-size-h1": "30px",
  "font-size-h2": "28px",
  "font-size-h3": "26px",
  "font-size-h4": "24px",
  "font-size-h5": "22px",
  "font-size-h6": "19px",
  "font-size-subtitle-1": "20px",
  "font-size-subtitle-2": "16px",
  "font-size-body-1": "16px",
  "font-size-body-2": "14px",
  "font-size-button": "16px",
  "font-size-caption": "14px",
  "font-size-small": " 10px",

  /* weights*/
  "font-weight-thin": 100,
  "font-weight-light": 300,
  "font-weight-regular": 400,
  "font-weight-medium": 500,
  "font-weight-bold": 700,

  /* misc */
  "font-family": "Inter",
  "font-line-height": "130%",
  "font-small-letter-spacing": "0.5px",

  "shadow-extra-small": "0 15px 10px 0",
  "shadow-small": "0 8px 16px 0",
  "shadow-medium": "0 15px 30px 0",
  "shadow-large": "0 10px 30px 0",

  "nav-height-desktop": "80px",
  "sidebar-background": "white",
  "sidebar-divider": "#d2b9fa",
  "sidebar-min-width": "275px",
  "sidebar-base-width": "20%",
  "sidebar-max-width": "420px",
  "page-x-padding": "1.5rem",
  "page-x-padding-mobile": "1rem",
  "form-item-base-height": "40px",
  "site-content-max-width": "1400px",
  "backdrop-background": "rgba(29, 20, 20, 0.3);",
  "body-background": "white",

  fonts: {
    // same for all
    header: `GT-Eesti, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol`,
    h1: `GT-Eesti, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol`,
    body: `GT-Eesti, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol`,
  },

  "green-100": "#d1e7dd",
  "green-300": "#75b798",
  "green-800": "#0a3622",

  "red-100": "#f8d7da",
  "red-300": "#ea868f",
  "red-800": "#58151c",
};

export default newTheme;
